import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import FormAddJob from "../../components/FormAddJob";
import { useAlert } from "../../context/AlertContext";
import { trackEvent } from "../../hooks/useAnalytics";
import { useScrollLock } from "../../hooks/useScrollLock";
import { ROUTES } from "../../routes/RouteNames";

const AddJob = ({ isEdit }) => {
    const [loading, setLoading] = useState(true);
    const [initialData, setInitialData] = useState(null);
    const [previousJob, setPreviousJob] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();
    const { showAlert } = useAlert();

    useScrollLock(loading);

    const fetchJobData = async (jobId) => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`/jobs/${jobId}`);
            setInitialData(response.data);
        } catch (error) {
            if (error.response?.status === 403) {
                showAlert("error", "Nemáte oprávnění vidět tuto stránku.");
            } else {
                showAlert("error", "Nepodařilo se načíst nabídku.");
            }
            navigate(ROUTES.JOBS);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isEdit) {
            if (id) {
                fetchJobData(id);
            } else {
                setLoading(false);
            }
        } else {
            const fetchPreviousJob = async () => {
                try {
                    const response = await axiosInstance.get("/jobs/latest");
                    setPreviousJob(response.data);
                } catch (error) {
                    if (error.response?.status === 401) {
                        console.warn("Neověřený přístup při načítání poslední nabídky — uživatel bude přesměrován na přihlášení.");
                    } else if (error.response?.status !== 404) {
                        showAlert(
                            "error",
                            "Nepodařilo se načíst poslední nabídku. Předvyplní se dnešní datum.",
                        );
                    }
                } finally {
                    setLoading(false);
                    trackEvent("page_view", { page: "add_job" });
                }
            };
            fetchPreviousJob();
        }
    }, [isEdit, id]);

    if (loading) {
        return (
            <div className="loader_container">
                <div className="loader"></div>
            </div>
        );
    }

    return (
        <div className="general_form">
            <h1>
                {isEdit ? "Úprava nabídky práce" : "Nabídka práce"}
            </h1>
            <FormAddJob
                initialData={initialData}
                previousJob={previousJob}
                isEdit={isEdit}
            />
        </div>
    );
};

export default AddJob;
